import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, IMAGES } from "@/data/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "glass shadow-[0_8px_32px_rgba(48,66,56,0.06)]" : "bg-transparent"}`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <button onClick={() => go("#hero")} className="flex items-center" data-testid="brand-logo">
          <img src={IMAGES.logoDark} alt="Proxilia" className="h-7 md:h-8 w-auto object-contain" />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-forest/80 hover:text-forest transition-colors relative group"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-gold transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            onClick={() => go("#rappel")}
            className="bg-forest text-cream px-6 py-2.5 rounded-full text-sm font-medium transition-all hover:bg-forestdark active:scale-95"
            data-testid="nav-cta"
          >
            Être rappelé
          </button>
        </nav>

        <button className="md:hidden text-forest" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden glass overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {NAV_LINKS.map((l) => (
                <button key={l.href} onClick={() => go(l.href)} className="text-left text-forest font-medium py-1" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
                  {l.label}
                </button>
              ))}
              <button onClick={() => go("#rappel")} className="bg-forest text-cream px-6 py-3 rounded-full text-sm font-medium mt-2">
                Être rappelé
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
